import {useEffect} from "react";
import {Confirm} from "notiflix/build/notiflix-confirm-aio";
import _ from "../Trans";


const noticeTitle = _("Aviso para la jornada 3");
//const noticeMessage = _("The match <b>Barça - Ademar León</b> will be postponed.<br><br>The players of these teams will not score points this week, although their points will count for average once played. We recommend selling them for round 3.<br><br>Consult <a href='/rules/#other-considerations' class='font-weight-bold'>the rules, section Other considerations</a>, to know more about this.");
const noticeMessage = _("Debido al aplazamiento del encuentro Tubos Aranda Villa de Aranda - Barça los jugadores de estos equipos no puntuarán esta jornada.<br/><br/>Los cambios relacionados con jugadores de ambos equipos no computarán en la limitación de 2 compras y 2 ventas.<br/><br/>Consulta las reglas acerca de cambios <a href='https://fantasy.asobal.es/rules/' target='_blank' style='color: dodgerblue'>aquí.</a>");
const noticeAcknowledge = _('Acknowledge');
const noticeDismiss = _('Do not show again');

export default function Alerts({alerts=null}) {
    const shouldDisplayAlert = function (alerts) {
        return false;
        if(alerts == null) {
            return false;
        }
        const TIME_TO_DISPLAY_AGAIN = 1000 * 60 * 60 * 24;
        // const TIME_TO_DISPLAY_AGAIN = 1000 * 60;  // test purposes
        return alerts?.match35405195 === undefined || (
            (new Date().getTime() - alerts?.match35405195?.lastTimeDisplayed > TIME_TO_DISPLAY_AGAIN)
            && alerts?.match35405195?.showAgain === true
        )
    }

    useEffect(() => {
        let alerts = localStorage.getItem('alerts');
        if (alerts === undefined) {
            alerts = {};
        }
        alerts = typeof alerts === 'string' ? JSON.parse(alerts) : {};
        // 1 day = 86400000
        if (shouldDisplayAlert(alerts)) {
            Confirm.show(
                noticeTitle,
                noticeMessage,
                noticeAcknowledge,
                noticeDismiss,
                () => {
                    if (alerts !== 'object') {
                        alerts = {};
                    }
                    alerts.match35405195 = {lastTimeDisplayed: new Date().getTime(), showAgain: true}
                    localStorage.setItem('alerts', JSON.stringify(alerts));
                },
                () => {
                    if (alerts !== 'object') {
                        alerts = {};
                    }
                    alerts.match35405195 = {lastTimeDisplayed: new Date().getTime(), showAgain: false}
                    localStorage.setItem('alerts', JSON.stringify(alerts));
                },
                {
                    width: "350px",
                    plainText: false,
                    messageMaxLength: 5000,
                    cancelButtonBackground: 'grey'
                }
            );
        }
    }, [alerts]);

    return "";
}